export const LOCAL_KEYS = {
  FILTER_VALUES: 'filterValues',
  FIRST_BANNER: 'firstBanner'
}
